/** Props for the FieldDescription component. */
interface FieldDescriptionProps {
  description?: string;
}

/**
 * Renders a subtle helper description below a custom field label.
 * Returns null when no description is provided.
 * @param description - Optional description text to display
 * @returns A styled paragraph element or null
 */
export function FieldDescription({ description }: FieldDescriptionProps) {
  if (!description) {
    return null;
  }

  return (
    <p className="text-xs text-muted-foreground opacity-50 italic">
      {description}
    </p>
  );
}
